import {useSelector} from 'react-redux';
import {useAbortableLoad} from "../../Hooks";
import {useParams} from 'react-router-dom'
import DirectoryBody from "../../Components/DirectoryBody";
import ContentContainer from "../../Components/ContentContainer/ContentContainer.js";

import mapStateToProps from './mapStateToProps.js'
import {Typography} from "@mui/material";
import {BURGER_MENU_LIST} from "../../Components/BurgerMenusToggler/constants";
import DirectoryBurgerMenuShowButton from "../../Components/DirectoryBurgerMenusToggler";
import {useMemo} from "react";
import {storageKeys} from "../../shared/constants/storageKeys";
import "./style.css";

const Directory = () => {

    const { dirname } = useParams();

    const {
        directoryList: {
            data: list= []
        } = {},
        rights,
        getDirectoryData =()=> {},
        burgerMenuOpened
    } = useSelector(mapStateToProps)

    const rightCheker = (dir, right) => {
        if(!dir) return false
        const nt=`dir${dir.substring(0,1).toUpperCase()}${dir.substring(1)}`;
        return !!(rights?.[`${nt}-${right}`])
    }

    const directoryData = useAbortableLoad(
      'getDirectoryData', 
      'directoryData',
      {dictId: dirname},
      rightCheker(dirname, 'view'),
      [rightCheker(dirname, 'view'), dirname]
    )

    const dirLabel = useMemo(() => {

        let listToSearch = list

        if (localStorage.getItem(storageKeys.DIRECTORY_LIST)) {
            listToSearch = JSON.parse(localStorage.getItem(storageKeys.DIRECTORY_LIST))
        }

        return listToSearch.find(({id})=> id === dirname)
    }, [list?.length, dirname])

    return (
        <ContentContainer
            content={((dirname && rightCheker(dirname, 'view')) || burgerMenuOpened?.name === BURGER_MENU_LIST.DIRECTORY) ? (
                <DirectoryBody
                    nameUi={list?.[dirname]?.name}
                    dictId={dirname}
                    fields={dirLabel?.fields}
                    update={()=>{getDirectoryData({
                        dictId: dirname
                    })}}
                    label={dirLabel?.name}
                    rightCheker={(right)=>rightCheker(dirname, right)}
                    directoryData={directoryData}
                />

            ) : (

                <div className={'buttonsContainer'}>
                    <DirectoryBurgerMenuShowButton />
                    <Typography marginX={'20px'}>Выберите справочник для работы с ним</Typography>
                </div>
            )}
        />

    )
}

export default Directory
